import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "personal-data-form",
  ref: "infoForm"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_6 = { class: "standard-input" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { for: "fName" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_10 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_11 = { class: "standard-input" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { for: "mName" }
const _hoisted_14 = { class: "standard-input" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { for: "lName" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_18 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_19 = { id: "personGender" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_21 = ["value", "onChange"]
const _hoisted_22 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_23 = { id: "personDOB" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_25 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_26 = {
  key: 0,
  class: "address"
}
const _hoisted_27 = { class: "standard-input" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { for: "address" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_31 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_32 = { class: "postal-city-wrapper" }
const _hoisted_33 = { class: "standard-input" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { for: "postalcode" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_37 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_38 = { class: "standard-input" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { for: "city" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_42 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_43 = { id: "countryWrapper" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_45 = ["value", "onChange"]
const _hoisted_46 = {
  key: 1,
  class: "standard-input"
}
const _hoisted_47 = ["value"]
const _hoisted_48 = { for: "country" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_50 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "standard-input" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { for: "phone" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_56 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_57 = {
  id: "email",
  class: "standard-input"
}
const _hoisted_58 = ["value"]
const _hoisted_59 = { for: "email" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("sup", null, "*", -1)
const _hoisted_61 = {
  class: "field-error",
  role: "alert",
  hidden: ""
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_EasyDobPicker = _resolveComponent("EasyDobPicker")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("fieldset", _hoisted_2, [
      (_ctx.person.isAdult)
        ? (_openBlock(), _createElementBlock("legend", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAdult']) + " " + _toDisplayString(_ctx.person.personTypeIndex + 1) + " ", 1),
            _createElementVNode("small", null, "(" + _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAdult']) + " " + _toDisplayString(_ctx.person.personTypeIndex
        + 1) + " " + _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelOutOf']) + " " + _toDisplayString(_ctx.adultsCount) + ")", 1)
          ]))
        : (_openBlock(), _createElementBlock("legend", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelChild']) + " " + _toDisplayString(_ctx.person.personTypeIndex + 1) + " • " + _toDisplayString(_ctx.person.searchPerson.age) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelBirthdateYear']), 1),
            _hoisted_5,
            _createElementVNode("small", null, "(" + _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelChild']) + " " + _toDisplayString(_ctx.person.personTypeIndex + 1) + " " + _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelOutOf']) + " " + _toDisplayString(_ctx.childrenCount) + ")", 1)
          ])),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", {
          id: "fName",
          type: "text",
          name: "firstName",
          value: _ctx.searchPerson.firstName,
          placeholder: " ",
          required: "",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
        }, null, 40, _hoisted_7),
        _createElementVNode("label", _hoisted_8, [
          _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelFirstname']) + " ", 1),
          _hoisted_9,
          _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAsInPassport']), 1)
        ]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelFirstname'])), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("input", {
          id: "mName",
          type: "text",
          name: "middleName",
          value: _ctx.searchPerson.middleName,
          placeholder: " ",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
        }, null, 40, _hoisted_12),
        _createElementVNode("label", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelMiddlename']) + " ", 1),
          _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAsInPassport']), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("input", {
          id: "lName",
          type: "text",
          name: "lastName",
          value: _ctx.searchPerson.lastName,
          placeholder: " ",
          required: "",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
        }, null, 40, _hoisted_15),
        _createElementVNode("label", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelLastname']) + " ", 1),
          _hoisted_17,
          _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAsInPassport']), 1)
        ]),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelLastname'])), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_EasyDrop, {
          customClasses: 'standard personal-info-select',
          dropdownType: 'select',
          useLabel: true,
          selectButtonValue: _ctx.genderButtonValue
        }, {
          buttonText: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelGender']) + " ", 1),
            _hoisted_20,
            _createElementVNode("small", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAsInPassport']), 1)
          ]),
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (gender, index) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "standard option",
                key: index
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  name: "userGender",
                  value: gender.id,
                  onChange: ($event: any) => (_ctx.updateGender(gender))
                }, null, 40, _hoisted_21),
                _createElementVNode("span", null, _toDisplayString(gender.name), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["selectButtonValue"]),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelGender'])), 1)
      ])
    ]),
    _createElementVNode("fieldset", _hoisted_23, [
      _createElementVNode("legend", null, [
        _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelBirthdate']) + " ", 1),
        _hoisted_24
      ]),
      _createVNode(_component_EasyDobPicker, {
        dob: _ctx.dob,
        pageTexts: _ctx.pageTexts,
        localeStrings: _ctx.localeStrings,
        onUpdateDob: _ctx.updateDob
      }, null, 8, ["dob", "pageTexts", "localeStrings", "onUpdateDob"]),
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelBirthdate'])), 1)
    ]),
    (_ctx.isContactPerson)
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_26, [
          _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddress']), 1),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("input", {
              id: "address",
              type: "text",
              name: "street",
              value: _ctx.searchPerson.street,
              placeholder: " ",
              required: "",
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
            }, null, 40, _hoisted_28),
            _createElementVNode("label", _hoisted_29, [
              _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressStreet']) + " ", 1),
              _hoisted_30
            ]),
            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressStreet'])), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("input", {
                id: "postalcode",
                type: "text",
                name: "postal",
                value: _ctx.searchPerson.postal,
                placeholder: " ",
                required: "",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
              }, null, 40, _hoisted_34),
              _createElementVNode("label", _hoisted_35, [
                _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressPostal']) + " ", 1),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressPostal'])), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("input", {
                id: "city",
                type: "text",
                name: "city",
                value: _ctx.searchPerson.city,
                placeholder: " ",
                required: "",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
              }, null, 40, _hoisted_39),
              _createElementVNode("label", _hoisted_40, [
                _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressCity']) + " ", 1),
                _hoisted_41
              ]),
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressCity'])), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            (_ctx.countries.length > 1)
              ? (_openBlock(), _createBlock(_component_EasyDrop, {
                  key: 0,
                  id: 'country',
                  customClasses: 'standard personal-info-select',
                  dropdownType: 'select',
                  useLabel: true,
                  selectButtonValue: _ctx.countryButtonValue
                }, {
                  buttonText: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepDropdownChooseCountry']) + " ", 1),
                    _hoisted_44
                  ]),
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                      return (_openBlock(), _createElementBlock("label", {
                        class: "standard option",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "radio",
                          name: "userCountry",
                          value: country.id,
                          onChange: ($event: any) => (_ctx.updateCountry(country))
                        }, null, 40, _hoisted_45),
                        _createElementVNode("span", null, _toDisplayString(country.name), 1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["selectButtonValue"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("input", {
                    id: "country",
                    type: "text",
                    name: "country",
                    value: _ctx.searchPerson.country?.name,
                    placeholder: " ",
                    required: "",
                    readonly: ""
                  }, null, 8, _hoisted_47),
                  _createElementVNode("label", _hoisted_48, [
                    _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressCountry']) + " ", 1),
                    _hoisted_49
                  ])
                ])),
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelAddressCountry'])), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isContactPerson)
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_51, [
          _createElementVNode("legend", null, _toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelContactInfo']), 1),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("input", {
              id: "phone",
              type: "text",
              name: "phone",
              value: _ctx.searchPerson.phone,
              placeholder: " ",
              required: "",
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updatePerson && _ctx.updatePerson(...args)))
            }, null, 40, _hoisted_53),
            _createElementVNode("label", _hoisted_54, [
              _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelContactInfoPhone']) + " ", 1),
              _hoisted_55
            ]),
            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelContactInfoPhone'])), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("input", {
              type: "email",
              name: "email",
              value: _ctx.searchPerson.email,
              placeholder: " ",
              required: "",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args)))
            }, null, 40, _hoisted_58),
            _createElementVNode("label", _hoisted_59, [
              _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPagePersonalInformationStepLabelContactInfoEmail']) + " ", 1),
              _hoisted_60
            ]),
            _createElementVNode("div", _hoisted_61, [
              (_ctx.emailHasError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.pageTexts['hotelPageGeneralFormValidationInvalidEmail']), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.errorMessage(_ctx.pageTexts['hotelPagePersonalInformationStepLabelContactInfoEmail'])), 1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}